/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountingFormulaValidationRequest
 */
export interface AccountingFormulaValidationRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountingFormulaValidationRequest
     */
    expression: string;
    /**
     * 
     * @type {string}
     * @memberof AccountingFormulaValidationRequest
     */
    dataProviderKey?: string;
}

/**
 * Check if a given object implements the AccountingFormulaValidationRequest interface.
 */
export function instanceOfAccountingFormulaValidationRequest(value: object): value is AccountingFormulaValidationRequest {
    if (!('expression' in value) || value['expression'] === undefined) return false;
    return true;
}

export function AccountingFormulaValidationRequestFromJSON(json: any): AccountingFormulaValidationRequest {
    return AccountingFormulaValidationRequestFromJSONTyped(json, false);
}

export function AccountingFormulaValidationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountingFormulaValidationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'expression': json['expression'],
        'dataProviderKey': json['dataProviderKey'] == null ? undefined : json['dataProviderKey'],
    };
}

export function AccountingFormulaValidationRequestToJSON(json: any): AccountingFormulaValidationRequest {
    return AccountingFormulaValidationRequestToJSONTyped(json, false);
}

export function AccountingFormulaValidationRequestToJSONTyped(value?: AccountingFormulaValidationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expression': value['expression'],
        'dataProviderKey': value['dataProviderKey'],
    };
}

